import React from 'react';
import { motion } from 'framer-motion';
import { Check, BookOpen, PenTool, Video, Users, ClipboardList, FileText, BarChart } from 'lucide-react';
export function WhatsIncluded() {
  const items = [{
    icon: BookOpen,
    text: 'PDF eBook completo (7 capítulos paso a paso)'
  }, {
    icon: PenTool,
    text: 'Prompts LatinoBoost copy-paste (comida, fitness, belleza)'
  }, {
    icon: Video,
    text: '10 Templates CapCut descargables'
  }, {
    icon: Users,
    text: '100 FB Groups latinas USA (lista curada)'
  }, {
    icon: ClipboardList,
    text: 'Checklists y worksheets cada capítulo'
  }, {
    icon: FileText,
    text: 'Contrato Zelle simple'
  }, {
    icon: BarChart,
    text: 'Tracker $500/semana Google Sheet'
  }];
  return <section className="py-20 bg-white" data-id="element-224">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-225">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-226">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D1B0E] mb-4" data-id="element-227">
            📦 Todo Lo Que Recibes
          </h2>
          <p className="text-xl text-[#2D1B0E]/70" data-id="element-228">
            Herramientas profesionales simplificadas para ti
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto mb-12" data-id="element-229">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex items-start gap-4 p-6 bg-[#FFF8F0] rounded-xl border border-[#D4A853]/20 hover:border-[#D4A853] transition-colors" data-id="element-230">
              <div className="flex-shrink-0 w-10 h-10 bg-[#1A6B5C]/10 rounded-full flex items-center justify-center text-[#1A6B5C]" data-id="element-231">
                <item.icon className="w-5 h-5" data-id="element-232" />
              </div>
              <div data-id="element-233">
                <p className="font-medium text-[#2D1B0E]" data-id="element-234">{item.text}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-235">
          <div className="inline-block bg-[#D4A853] text-white px-8 py-4 rounded-full text-xl font-bold shadow-lg transform hover:scale-105 transition-transform" data-id="element-236">
            Valor total: <span className="line-through opacity-70" data-id="element-237">$197+</span>{' '}
            → Hoy solo $17
          </div>
        </motion.div>
      </div>
    </section>;
}